export default __webpack_public_path__ + "static/media/hc-7.d20be328.mp4";